import {runWaffleSync, getWaffleSyncProgress} from "../_resources/waffle-helpers.js"
      

function formatSyncEvent(events) {
  return events.length > 0 ? events.at(-1).comment : "";
}

export async function syncDataset({selectedServerUrl, slug, branch, token, good, info, progress, bad, refresh}){
  
  const {ok: syncResponse, error} = await runWaffleSync(selectedServerUrl, slug, branch, token);
  if (error) return bad(error); //❌

  progress(formatSyncEvent(syncResponse.events))
  
  let intervalRetryCount = 0;
  const interval = setInterval(async ()=>{
    const {ok: syncProgressResponse, error} = await getWaffleSyncProgress(selectedServerUrl);
    if (error || !syncProgressResponse) {
      intervalRetryCount++;
      if (intervalRetryCount > 3) clearInterval(interval);
      return bad(error || "Sync progress came back empty :("); //❌
    }

    if(syncProgressResponse.ongoing)
      return progress(formatSyncEvent(syncProgressResponse.events))

    good(formatSyncEvent(syncProgressResponse.events), 2000); //✅
    refresh();
    clearInterval(interval);

  }, 500);
  
}